const staticText = {
  textHeader: 'Verify Password',
  modalTitle: 'Verify password',
  textBody: 'Please enter your password to update your email address',
  verify: 'Verify',
  cancel: 'Cancel',
};

export default staticText;
